export const ACTIVATE_APPLY_FLEXI_LOAN = 'page/APPLY_FLEXI_LOAN [activate]';
export const DEACTIVATE_APPLY_FLEXI_LOAN = 'page/APPLY_FLEXI_LOAN [deactivate]';

export const APPLY_FLEXI_LOAN_DATA = 'page/APPLY_FLEXI_LOAN [data]';

export const CREATE_APPLICATION = 'page/CREATE_APPLICATION';
export const CREATE_APPLICATION_SUCCESS = `${CREATE_APPLICATION} [success]`;

export const APPLY_FLEXI_LOAN_SUBMIT_APPLICATION =
    'page/APPLY_FLEXI_LOAN_SUBMIT_APPLICATION';
export const APPLY_FLEXI_LOAN_SUBMIT_APPLICATION_SUCCESS = `${APPLY_FLEXI_LOAN_SUBMIT_APPLICATION} [complete]`;

export const DOCUMENT_REQUIREMENTS_LOADING =
    'page/DOCUMENT_REQUIREMENTS [loading]';
export const DOCUMENT_REQUIREMENTS_COMPLETE =
    'page/DOCUMENT_REQUIREMENTS [complete]';

export const UPLOAD_FLEXI_LOAN_DOCUMENT_REQUIREMENT =
    'page/UPLOAD_FLEXI_LOAN_DOCUMENT_REQUIREMENT';

export const SHOW_APPLICATION_STEP = 'page/SHOW_APPLICATION_STEP';
export const SHOW_UPLOAD_DOCUMENTS_STEP = 'page/SHOW_UPLOAD_DOCUMENTS_STEP';
